import { Injectable } from '@angular/core';
import { ApiAutoCompleteService, FieldSelectOption } from 'components/shared';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CodeWrapperService } from '../service-wrappers/code-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class SpecialtyCodesLookupService extends ApiAutoCompleteService {
  constructor(private service: CodeWrapperService) {
    super();
  }

  mapRow(result) {
    return {
      value: result.id,
      label: result.name
    };
  }

  search(value: string): Observable<FieldSelectOption[]> {
    return this.service
      .apiV1CodeCodetypePost('SpecialtyCode', {
        generalSearch: value
      })
      .pipe(map((results) => results.data.map(this.mapRow)));
  }
}
